var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.option.data),expression:"option.data"}],attrs:{"type":"text"},domProps:{"value":(_vm.option.data)},on:{"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.option, "data", $event.target.value)},_vm.changeOptionEvent]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }